export const FC_SPC_CONFIG: any = {
  widgetUrl: process.env.REACT_APP_WIDGETS_BASE_PATH
    ? process.env.REACT_APP_WIDGETS_BASE_PATH + '/finance-calculator-react/library'
    : process.env.REACT_APP_FC_WIDGET_PATH,
  paths: {
    chunkPath: process.env.REACT_APP_WIDGETS_BASE_PATH ? '/modules.fc.chunk.js' : '/legacy-widget.fc.chunk.js',
    widgetPath: '/fc.js',
  },
  dxpWidgetUrl:
    process.env.REACT_APP_DXP_WIDGETS_BASE_PATH +
    `${process.env.REACT_APP_COUNTRY}/${process.env.REACT_APP_BRAND_CODE}/widgets/finance-calculator/dist/finance-calculator.esm.js`,
};
